var escape = require("../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "@font-face{font-family:DingTalk JinBuTi;src:url(" + escape(require("./DingTalk+JinBuTi.woff2")) + ") format(\"woff2\");font-weight:400;font-style:normal;font-display:swap}", "", {"version":3,"sources":["/app/workspace/DEPLOY/esg-cr-core/esg-cr-core-nginx-campus-mobile/src/assets/font/fonts.css"],"names":[],"mappings":"AAAA,WACE,6BAA+B,AAC/B,kDAAoD,AACpD,gBAAmB,AACnB,kBAAkB,AAClB,iBAAkB,CACpB","file":"fonts.css","sourcesContent":["@font-face {\n  font-family: \"DingTalk JinBuTi\";\n  src: url(\"./DingTalk+JinBuTi.woff2\") format(\"woff2\");\n  font-weight: normal;\n  font-style: normal;\n  font-display: swap;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--5-1!./node_modules/postcss-loader/src??ref--5-2!./src/assets/font/fonts.css
// module id = Gba4
// module chunks = 66